import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getClockFormat } from "reduxSlices/currentSettingsSlice"
import { timeByClockFormat } from "utils/dateHelpers"

const TimeDataElement = ({ value = "" }) => {
  const clockFormat = useSelector(getClockFormat)

  if (!value) return ""

  return (
    <span>
      { timeByClockFormat(value, clockFormat) }
    </span>
  )
}

TimeDataElement.propTypes = {
  value: types.string,
}

export default TimeDataElement
